import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

const LogoIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className,
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className || ''}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      onClick={onClick}
      data-testid="logo-icon"
      fill={fill || '#7E8A96'}
      viewBox="0 0 132 131"
    >
      <path
        fill={fill || '#7E8A96'}
        d="M130.979 33.763A3.442 3.442 0 00132 31.318V3.457C132 1.548 130.44 0 128.515 0H0v46.219c0 2.091 1.856 3.704 3.944 3.428l26.343-3.476V30.057h52.128L30.287 81.79V68.192L1.021 97.237A3.443 3.443 0 000 99.682v27.86C0 129.452 1.56 131 3.485 131H132V84.658c0-2.09-1.856-3.703-3.944-3.428l-26.343 3.476v16.236H49.585l52.128-51.733v13.598l29.266-29.044z"
      />
      <path
        fill={fill || '#7E8A96'}
        d="M35.713 35.442V68.79l33.603-33.348H35.713zm26.971 60.115h33.603V62.21L62.684 95.557z"
      />
    </svg>
  );
};

export default LogoIcon;
